import { useContext } from 'react'

import { LoadingIcon, Stack } from '@cash-design-system/react'
import logger from '@cash-web/shared/util-logger'
import { FlowContext } from '@cash-web/shared-flow-data-access-context'
import { useExecuteOnce } from '@cash-web/shared-util-execute-once'

import { getFlowConfiguration } from './getFlowConfiguration'
import { parseFlowTypeFromInitiationData } from './utils'

export const GetFlow = ({ initiationData, flowType }: { initiationData?: string; flowType?: string }) => {
  const flowData = initiationData ?? flowType

  const flowTypeKey = parseFlowTypeFromInitiationData(flowData)

  const flowConfig = flowTypeKey ? getFlowConfiguration[flowTypeKey as keyof typeof getFlowConfiguration] : undefined
  if (flowConfig == null) {
    logger.error(new Error(`No flow configuration found for flow type ${flowTypeKey}`))
  }

  const flow = useContext(FlowContext)

  useExecuteOnce(async () => {
    if (flowData != null) {
      flow.startWithFlow({
        flow: {
          initiationData: flowData,
        },
        queriesToInvalidate: 'ALL',
        // convert from uppercase with underscore to lowercase with hyphen
        trackingFlowName: `journey-get-flow-${flowTypeKey?.replace(/_/g, '-').toLowerCase()}`,
        ...flowConfig,
      })
    }
  }, flowData != null)

  return (
    <Stack space={'l'} justifyItems="center">
      <LoadingIcon />
    </Stack>
  )
}
